import { getReactComponent } from "../../../state/react-page";
import { useSelector } from "./use-selector";
function useComponent(type) {
  return useSelector((state) => getReactComponent(state, type));
}
export {
  useComponent
};
//# sourceMappingURL=use-component.js.map